import React, { Component } from "react";
import {getStaticText} from '../../../lables/lablesService';
import {PaginationButtons} from '../../../components/pagination-component/pagination';
import {SortableButton} from '../../../components/sortable-button-component/sortableButton';


class PostsList extends Component {

    async editButton ( row_key = 0 ) {
    	if ( typeof(this.props.posts[row_key]) === 'undefined' )
            return false;

        if ( typeof(this.props.editFunction) === 'function' )
        	this.props.editFunction(this.props.posts[row_key]);
    }


    async deleteButton ( row_key = 0 ) {
    	if ( typeof(this.props.posts[row_key]) === 'undefined' )
            return false;
        if ( typeof(this.props.deleteFunction) === 'function' )
        	this.props.deleteFunction(this.props.posts[row_key]);
    }


	render () {
		let records = [];
		if ( !Object.keys(this.props.posts).length ) {
			records.push(<tr key="ttop_empty_row"><td colSpan="6">{getStaticText('ttop_table_empty_list_message')}</td></tr>);
		} else {
			for ( let row_key in this.props.posts ) {
				let post = this.props.posts[row_key];
				records.push(<tr key={"ttop_row_" + post.id}>
						<td>
							{post.id}
						</td>
						<td>
							{post.title}
						</td>
						<td>
							{this.props.types[post.type_id] || ''}
						</td>
						<td>
							{post.active ? getStaticText('ttop_table_body_active_yes_label') : getStaticText('ttop_table_body_active_not_label')}
						</td>
						<td>
							{post.position}
						</td>
						<td className="os-text-right">
							<button 
                                className="btn btn-sm btn-info text-white os-mr-1"
                                title={getStaticText('ttop_edit_button_title')}
                                onClick={this.editButton.bind(this, row_key)}
                            >
                                <span className="fa fa-edit"></span>
                            </button>
                            <button 
                                className="btn btn-sm btn-danger text-white"
                                title={getStaticText('ttop_delete_button_title')}
                                onClick={this.deleteButton.bind(this, row_key)}
                            >
                                <span className="fa fa-trash"></span>
                            </button>
						</td>
					</tr>);
			}
		}
		

		return (<>
				<div className="col-lg-12 pt-3">
					<div className="table-responsive">
	                    <table className="table table-bordered">
	                        <thead>
	                            <tr className="table-warning">
	                            	<th>
	                            		<SortableButton 
		                                    column="id"
		                                    currentSortable={this.props.order}
		                                    multiSortable={true}
		                                    callbackFunction={this.props.changeOrder}
		                                />
		                                {getStaticText('ttop_table_head_id_label')}
	                            	</th>
	                            	<th>
	                            		<SortableButton 
		                                    column="name"
		                                    currentSortable={this.props.order}
		                                    multiSortable={true}
		                                    callbackFunction={this.props.changeOrder}
		                                />
		                                {getStaticText('ttop_table_head_name_label')}
	                            	</th>
	                            	<th>
	                            		<SortableButton 
		                                    column="type_id"
		                                    currentSortable={this.props.order}
		                                    multiSortable={true}
		                                    callbackFunction={this.props.changeOrder}
		                                />
		                                {getStaticText('ttop_table_head_type_label')}
	                            	</th>
	                            	<th>
	                            		<SortableButton 
		                                    column="active"
		                                    currentSortable={this.props.order}
		                                    multiSortable={true}
		                                    callbackFunction={this.props.changeOrder}
		                                />
		                                {getStaticText('ttop_table_head_active_label')}
	                            	</th>
	                            	<th>
	                            		<SortableButton 
		                                    column="position"
		                                    currentSortable={this.props.order}
		                                    multiSortable={true}
		                                    callbackFunction={this.props.changeOrder}
		                                />
		                                {getStaticText('ttop_table_head_position_label')}
	                            	</th>
	                            	<th></th>
	                           	</tr>
	                        </thead>
	                        <tbody>
	                        	{records}
	                        </tbody>
	                    </table>
	                </div>
	            </div>

	            <div className="col-lg-12 pt-3 os-text-center">
                    <PaginationButtons 
                        activePage={this.props.page} 
                        allPages={this.props.all_pages}
                        callbackFunction={this.props.changePage}
                    />
                </div>
			</>);
	}
}


export default PostsList;